export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.67 4.258A9.959 9.959 0 0112 2c5.523 0 10 4.477 10 10a9.959 9.959 0 01-2.258 6.33 1.01 1.01 0 00-.035-.037l-14-14a1.044 1.044 0 00-.037-.035zM4.258 5.67A9.959 9.959 0 002 12c0 5.523 4.477 10 10 10a9.959 9.959 0 006.33-2.258 1.204 1.204 0 01-.037-.035l-14-14a.97.97 0 01-.035-.037zM12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0z\" fill=\"#ff00cb\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};